export class clientManagementUrl {
    ADD_CLIENT_URL = "suite/client/";
    ALL_CLIENTS_URL= "suite/client/all[?FilterText][&PageSize][&PageNumber][&SortBy][&SortOrder]";
    DELETE_CLIENT_URL = "suite/client/{uniqueId}";
    EDIT_CLIENT_URL = "suite/client/";
    UPLOAD_CLIENT_CSV_URL = "suite/client/upload-client-csv"
}